// Máscara e formatação de CEP no padrão "99999-999".
// Usada tanto pra mascarar digitação (inputs) quanto pra normalizar exibição
// de valores legados salvos sem hífen.

export function formatCep(value) {
  const digits = String(value ?? "").replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}
